export default "__VITE_ASSET__BaF09a_N__"